export enum UserRole {
	ADMIN = "orgill_admin",
	SUPER_ADMIN = "orgill_superAdmin",
	PRIMARY = "orgill_master",
	PROP65 = "orgill_prop65",
	NEW_PRIMARY = "newPrimary",
	NEW_PROP65 = "newProp65",
	CUSTOMER = "customer",
}

export const ROLE_NAMES = {
	orgill_admin: "Admin",
	orgill_superAdmin: "Super Admin",
	orgill_master: "Primary",
	orgill_prop65: "Prop65",
	newPrimary: "New Primary",
};
